module.exports = __webpack_public_path__ + "static/buildings-d83c08a60b299662b0f7a06a168893a0.jpg";